import { GetterTree } from 'vuex';
import { RootState, UserState } from '@/store';

export const getters: GetterTree<UserState, RootState> = {
};
